import React from 'react';
import {
  Box, Link, makeStyles,
} from '@material-ui/core';
import Typography from '#web-components/components/Typography';
import clsx from 'clsx';
import styles from './NavLink.styles';

export type NavLinkProps = {
  name: string,
  component: React.ElementType,
  to: string,
  selected?: boolean,
  icon?: React.ReactElement,
  disabled?: boolean,
};

const useStyles = makeStyles(styles, { name: 'NavLink' });

export default function NavLink({
  name,
  component,
  to,
  selected,
  icon,
  disabled,
}: NavLinkProps) {
  const classes = useStyles();
  return (
    <Link
      to={to}
      className={clsx(classes.root, {
        [classes.enabled]: !disabled && !selected,
        [classes.selected]: selected,
        [classes.disabled]: disabled,
      })}
      component={component}
      disabled={disabled}
    >
      {icon && (
        <Box className={classes.icon}>
          {icon}
        </Box>
      )}
      <Typography variant="accentTiny" className={classes.name}>
        {name}
      </Typography>
    </Link>
  );
}
